export default __webpack_public_path__ + "static/media/services_24_7.161e6cd2.svg";